import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { MyPersonalDataComponent } from './my-personal-data.component';
import { DeleteAccountDialogComponent } from './dialog/delete-account-dialog/delete-account-dialog.component';
import { MaterialModule } from '@app/shared/material.module';

@NgModule({
  declarations: [MyPersonalDataComponent, DeleteAccountDialogComponent],
  imports: [CommonModule, SharedModule, MaterialModule],
})
export class MyPersonalDataModule {}
